import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { IRoleState } from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const roleModule: Module<IRoleState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default roleModule
